<template>
<!-- 项目 - 设备预警 -->
  <div class="main-box">
      <div class="head-box">
        <span class="text">安全管理>预警信息</span>
        <el-select v-model="search.type" clearable placeholder="事件类型" @change="dofilter">
            <el-option
            v-for="item in types"
            :key="item.value"
            :label="item.name"
            :value="item.value">
            </el-option>
        </el-select>
        <el-select v-model="search.status" clearable placeholder="处理状态" @change="dofilter">
            <el-option
            v-for="item in statusList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
            </el-option>
        </el-select>
        <el-date-picker
            v-model="seachTime"
            type="daterange"
            align="right"
            unlink-panels
            value-format="yyyy-MM-dd"
            range-separator="~"
            start-placeholder="开始月份"
            end-placeholder="结束月份"
            @change="timefilter"
            :picker-options="pickerOptions">
        </el-date-picker>
        </div>
        <div class="table-box">
            <div class="main">
        <div class="scroll">
          <div class="box" v-for="(item,index) in listData" :key="index">
          <div class="box-t">
            {{item.jpushTitle}}
          </div>
          <div class="box-b">
            <div class="box-b-l">
              <div class="box-b-l-t">
                <div class="item">处理状态</div>
                <div class="item">发生设备</div>
                <div class="item">发生时间</div>
                <div class="item">处理人</div>
                <div class="item">处理方式</div>
                <div class="item">处理信息</div>
                <div class="item">项目负责人</div>
                <div class="item">联系电话</div>
              </div>
              <div class="box-b-l-b">
                <div class="item-text" :style="item.processStatus=='0'?'color:#E6A23C;':'color:#4B7FCD;'">{{item.processStatus=='0'?'待处理':'已处理'}}</div>
                <div class="item-text">{{item.equipName}}</div>
                <div class="item-text">{{item.createDate}}</div>
                <div class="item-text">{{item.userName||'--'}}</div>
                <div class="item-text">{{item.processMode||'--'}}</div>
                <div class="item-text">{{item.msg||'--'}}</div>
                <div class="item-text">{{item.projectEnt.name||'--'}}</div>
                <div class="item-text">{{item.projectEnt.phone||'--'}}</div>
              </div>
            </div>
            <div class="box-b-r" @click="showInfo(item)">
              详情查看
            </div>
          </div>
        </div>
        </div>
        <div  class="fenye">
            <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[5,10,20,50]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalItems"
        ></el-pagination>
      </div>


            <!-- <div class="table-item" v-for="(item,index) in listData" :key="index">
                <div class="table-item-con">
                    <p class="title nowrap">{{item.jpushTitle}}</p>
                    <p class="lable">处理状态：
                        <span style="color:#E6A23C;" v-if="item.processStatus=='0'">待处理</span>
                        <span style="color:#4B7FCD;" v-else>已处理</span>
                    </p>
                    <p class="lable nowrap">发生设备：{{item.equipName}}</p>
                    <p class="lable nowrap">发生时间：{{item.createDate}}</p>
                </div>
                <div class="table-item-con">
                    <p class="lable nowrap">处理人：{{item.userName||'--'}}</p>
                    <p class="lable nowrap">处理方式：{{item.processMode||'--'}}</p>
                    <p class="lable nowrap">处理信息：{{item.msg||'--'}}</p>
                </div>
                <div class="table-item-con">
                    <p class="lable nowrap">项目负责人：{{item.projectEnt.name||'--'}}</p>
                    <p class="lable nowrap">联系方式：{{item.projectEnt.phone||'--'}}</p>
                    <p class="lable nowrap"></p>
                </div>
                <div class="table-item-btn flex-center">
                    <el-button type="text" style="margin-right:1vw;" @click="showInfo(item)">详情</el-button>
                    <el-button v-if="item.processStatus=='0'" type="text" style="color:#000066;" @click="toUpdata(item)">立即处理</el-button>
                    <el-button v-if="item.processStatus=='0'" type="text" style="color:#f00;" @click="cancel(item)">取消预警</el-button>
                </div>
            </div>
            <div v-if="noData" style="width:100%;height:100%;display:flex;justify-content: center;align-content: center;align-items: center;">
                暂无数据
            </div> -->
        </div>
      </div>
      <!-- 新增窗口(处理) -->
      <el-dialog
        title="预警处理"
        :visible.sync="handleVisible"
        center
        :append-to-body="true"
        :lock-scroll="false"
        class="add-form"
        width="500px"
      >
        <el-form ref="form" :model="form" label-width="120px">
            <el-form-item label="处理人">
                <el-input v-model="form.userName" readonly></el-input>
            </el-form-item>
            <el-form-item label="处理方式">
                <el-input type="textarea" v-model="form.processMode"></el-input>
            </el-form-item>
            <el-form-item label="处理信息">
                <el-input type="textarea" v-model="form.msg"></el-input>
            </el-form-item>
            <div style="width:100%;height:8vh;display:flex;justify-content: center;align-content: center;align-items: center;">
                <el-button type="primary" @click="modSubmit" round style="width:80%;">确定提交</el-button>
            </div>
        </el-form>
      </el-dialog>
      <!-- 新增窗口(详情) -->
      <el-dialog
        title="预警详情"
        :visible.sync="infoVisible"
        center
        :append-to-body="true"
        :lock-scroll="false"
        custom-class="scene-dialog"
        class="add-form"
        width="60%"
        style="min-width:900px;"
      >
        <div class="head1">
            <!-- <img :src="info.imagePath" style="width:50%;height:100%;position: relative;" /> -->
            <!-- <div style="width:50%;height:100%;position: relative;display: flex;align-items: center;justify-content: center;">
                  <img :src="info.imagePath" style="max-width:100%;max-height:100%;" />
              </div> -->
            <div style="width:50%;height:100%;position: relative;padding-left:2vh;">
                <p style="height: 5vh;display: flex;align-items: center;font-size: 1.6vh;">预警类型：<span style="color:#993300;">{{info.jpushTitle}}</span></p>
                <p style="height: 5vh;display: flex;align-items: center;font-size: 1.6vh;">预警内容：{{info.jpushMsg}}</p>
                <p style="height: 5vh;display: flex;align-items: center;font-size: 1.6vh;">发生地点：{{info.equipName}}</p>
                <p style="height: 5vh;display: flex;align-items: center;font-size: 1.6vh;">预警时间：{{info.createDate}}</p>
            </div>
        </div>
        <h1 style="width:100%;padding:1vh;font-size:1.8vh;">处理信息</h1>
        <p style="padding:1vh 0 3vh 10vh;">处理状态：<span style="color:#4B7FCD;" v-if="info.processStatus=='1'">已处理</span><span style="color:#FF6633;" v-else>待处理</span></p>
        <div class="con" style="padding-left:14vh;">
            <el-timeline>
                <el-timeline-item timestamp="预警" placement="top" color="#108ee9" style="color:#000;" >
                    <div style="background:rgba(184, 221, 248, 0.2);padding:2vh;">
                        <p>{{info.jpushMsg}}</p>
                    </div>
                    <p style="position: absolute;top: -30px;left: -150px;width: 120px;color: #999;">{{info.createDate}}</p>
                </el-timeline-item>
                <el-timeline-item timestamp="处理完成" placement="top" v-if="info.status=='0'" color="#108ee9" style="color:#000;" >
                    <div style="background:rgba(184, 221, 248, 0.2);padding:2vh;">
                        <h4>处理人：{{info.userName}}</h4>
                        <p style="margin-top:1vh;">{{info.msg}}</p>
                    </div>
                    <p style="position: absolute;top: -30px;left: -150px;width: 120px;color: #999;">{{info.updateDate}}</p>
                </el-timeline-item>
                <el-timeline-item timestamp="待处理" placement="top" v-else color="#b8ddf8">
                    
                </el-timeline-item>
            </el-timeline>
        </div>
      </el-dialog>
  </div>
</template>

<script>
import myHttp from '../../../untils/port';
import util from '../../../untils/util';
export default {
    data(){
        return{
            search:{
                type:'',
                status:'',
            },
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                    picker.$emit('pick', [start, end]);
                    }
                }]
            },
            types:[   //事件类型
                {id:'2',name:'环境检测',value:'2'},
                {id:'3',name:'塔吊',value:'3'},
                {id:'4',name:'卸料平台',value:'4'},
                {id:'5',name:'升降机',value:'5'},
                {id:'6',name:'深基坑',value:'6'},
                {id:'7',name:'高支模',value:'7'},
                {id:'8',name:'大体积混凝土',value:'8'},
                {id:'10',name:'设备维保',value:'10'},
                {id:'12',name:'质量安全',value:'12'},
                {id:'1000',name:'进度偏移',value:'1000'},
                {id:'1001',name:'能耗',value:'1001'},
                {id:'1002',name:'工资异常',value:'1002'},
            ],
            statusList:[{label:'待处理',value:'0'},{label:'已处理',value:'1'}],
            currentPage:1,
            pageSize:10,
            totalItems:0,
            groupId:'',
            seachTime:'',
            listData:[],//列表
            noData:false,//是否有数据
            dialogTitle:'预警详情',//
            handleVisible:false,
            form:{   //预警处理
                id:'',
                userName:'',
                userId:'',
                msg:'',
                processMode:'',
            },
            infoVisible:false,//详情弹出框
            info:{  //详情信息

            },
        }
    },
    mounted(){
        // this.seachTime = util.myTime.getCurWeek()
        this.groupId = util.session.get('groupId')
        // this.getTypeList()
        this.getData()
    },
    methods:{
        //获取事件类型
        getTypeList(){
            var that = this
            myHttp.getTopicValueList().then(function(resp){
                if(resp.data.code=="200"){
                    var list = resp.data.data.aiEquipCameraTopics||[];
                    that.types = list;
                }else{
                    that.$message.error(resp.data.msg);
                }
            },function(){});
        },
        //条件过滤
        dofilter(){
            this.getData()
        },
        //时间过滤
        timefilter(){
            this.getData()
        },
        handleSizeChange(val) {
            console.log(val,'-000')
            this.pageSize = val
            // this.handleCurrentChange()
            this.currentChangePage()
        },
        handleCurrentChange(val) {
            console.log(val,'-222')
            this.currentPage = val
            this.currentChangePage()
        },
        // 监控当前页码
        currentChangePage(list) {
            this.getData()
        },
        getData(){
            var that = this
            myHttp.selectSysJpushMsgAllPage({
                projectId:this.groupId,
                pageNum:this.currentPage,
                pageSize:this.pageSize,
                processStatus:this.search.status,
                jpushNoticeType:this.search.type,
                startTime:this.seachTime[0],
                endTime:this.seachTime[1],
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.pageInfo.list||[]
                    for(var i=0;i<list.length;i++){
                        if(list[i].jpushNoticeType=='3'){
                            list[i].imagePath = require('../../../assets/image/visual/warn3.png')
                        }else if(list[i].jpushNoticeType=='4'){
                            list[i].imagePath = require('../../../assets/image/visual/warn1.png')
                        }else if(list[i].jpushNoticeType=='5'){
                            list[i].imagePath = require('../../../assets/image/visual/warn5.png')
                        }else if(list[i].jpushNoticeType=='6'){
                            list[i].imagePath = require('../../../assets/image/visual/warn2.png')
                        }else if(list[i].jpushNoticeType=='7'){
                            list[i].imagePath = require('../../../assets/image/visual/warn6.png')
                        }
                    }
                    that.listData = list
                    that.totalItems = resp.data.data.pageInfo.total||0
                    if(list.length==0){
                        that.noData = true
                    }else{
                        that.noData = false
                    }
                }else{
                    that.noData = true
                }
            })
        },

        //处理弹出框
        toUpdata(row){
            this.form.id = row.id
            this.form.userName = util.session.get('user').name
            this.form.userId = util.session.get('user').id
            this.form.msg = ''
            this.form.processMode = ''
            this.handleVisible = true
        },
        //处理
        modSubmit(){
            var that = this
            myHttp.processingWarning(this.form).then(function(resp){
                if(resp.data.code=='200'){
                    that.handleVisible = false
                    that.getData()
                    that.$message.success('处理成功');
                }else{
                    that.$message.error(resp.data.msg);
                }
            })
        },
        // 取消预警
        cancel(row){
          var that = this
            this.$confirm('此操作将永久取消预警, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
            .then(() => {
            myHttp
                .deleteSysJpushMsgAll({
                id: row.id
                })
                .then(function(resp) {
                if (resp.data.code == '200') {
                    that.$message({
                    type: 'success',
                    message: '取消成功!'
                    })
                    that.getData()
                } else {
                    that.$message.error(resp.data.msg)
                }
                })
            })
            .catch(err => {})
        },
        //展示内容
        showInfo(row){
            //var that = this
            this.info = row
            this.infoVisible = true
        },
    }
}
</script>

<style scoped>
    .main-box{
        width: 100%;
        height: 100%;
        position: relative;
        /* padding: 1vw; */
        background: #fff;
        display: flex;
        flex-direction: column;
    }
    .head-box{
        width: 100%;
        height: 6vh;
        position: relative;
        display: flex;
        justify-content: flex-end;
        align-content: center;
        align-items: center;
        background: #f2f2f2;
        padding-left: 5px;
    padding-right: 23px
    }
    
    .table-box{
        width: 100%;
        height: 100%;
        position: relative;
        overflow: auto;
        background-color: #f2f2f2;;
    }
    .table-item{
        width: 100%;
        height: 16vh;
        padding: 2vh 2vh 0;
        position: relative;
        border-bottom: 1px solid #F2F2F2;
        display: flex;
    }
    .table-item-con{
        width: calc( 33% - 7vh );
        height: 100%;
        position: relative;
        display: flex;
        flex-wrap: wrap;
        align-content: center;
        align-items: center;
        padding-left: 4vw;
    }
    .table-item-btn{
        width: 20vh;
        height: 100%;
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
        justify-content: center;
        justify-items: center;
    }
    .table-item-con .title{
        width: 100%;
        height: 4vh;
        color: #993300;
        font-size: 1vw;
        position: relative;
        line-height: 4vh;
    }
    .table-item-con .lable{
        width: 100%;
        height: 3vh;
        position: relative;
    }
    .table-item-con p{
        text-align: left;
    }
    .flex-center{
        display: flex;
        justify-content: center;
        justify-items: center;
    }

    /* .scene-dialog{
        width:100
    } */
    .scene-dialog .head1{
        width: 100%;
        height: 27vh;
        padding: 0 1vh;
        margin-bottom: 3vh;
        position: relative;
        display: flex;
    }
    .main{
  flex: 1;
  background-color: #f2f2f2;
  padding-left:5px ;
  padding-right:23px ;
}
.nav-bar{
  height: 57px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.nav-bar-l{
  line-height: 57px;
}
.nav-bar-r{
  width: 28vw;
  display: flex;
  justify-content: space-between;
}
.nav-bar-r>button{
  width: 8vw;
  height: 4vh;
  background-color: #377dee;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.scroll{
  height: 79vh;
  overflow: scroll;
      background-color: #ffffff;
}
.scroll::-webkit-scrollbar{
  width: 0;
  height: 0;
}
.box{
  height: 16vh;
  display: flex;
  flex-direction: column;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0px 3px 7px 0px rgba(105, 159, 204, 0.35);
  margin-bottom: 4.5vh;
}

.box-t{
  height: 6vh;
  background-color: #e4ebf1;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: PingFang-SC-Bold;
	font-size: 24px;
	font-weight: normal;
	font-stretch: normal;
	line-height: 30px;
	letter-spacing: 10px;
	color: #333333;
}
.box-b{
  flex: 1;
  display: flex;
}
.box-b-l-t, .box-b-l-b{
  height: 50%;
  border-bottom: 1px solid #e7e7e7;
  display: flex;
}
.box-b-l-t{
  font-family: PingFang-SC-Medium;
	font-size: 20px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #333333;
}
.box-b-l-b{
  font-family: PingFang-SC-Medium;
	font-size: 20px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #666666;
}
.box-b-l-b:last-child{
  border-bottom: none;
}
.box-b-r{
  width: 10vw;
  height: 100%;
  cursor: pointer;
}
.box-b-l{
  flex: 1;
}
.item, .item-text{
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: solid 2px #e7e7e7;
  background-color: #fff;
}
.item{
  font-family: PingFang-SC-Medium;
	font-size: 20px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #333333;
}
.item-text{
  font-family: PingFang-SC-Medium;
	font-size: 20px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #666666;
}
.box-b-r{
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: PingFang-SC-Medium;
	font-size: 20px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #2e5be9;
  background-color: #fff;
}
/* .fenye{
    margin-top: 7px;
} */
.fenye>.el-pagination{
    background-color: #dfe1e3;
    border-radius: 10px 10px 0 0;
    height: 5vh;
    line-height: 5vh;
    padding-top:0.9vh !important; 
}
::v-deep .el-breadcrumb__inner{
  font-family: PingFang-SC-Regular;
	font-size: 18px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #000000;
}
.text{
    position: absolute;
    left: 5px;
    height: 100%;
    display: flex;
    align-items: center;
    font-family: PingFang-SC-Regular;
	font-size: 18px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #000000;
}
</style>
<style>
    @import '../../../assets/css/common.css'
</style>